import React from "react";

import Button from "../../../../../components/button/Button";

type AddWorkFormFooterProps = {
  onCancel: () => void;
  submitError: string | null;
  isSubmitting: boolean;
  isLoadingDefaults: boolean;
};

export const AddWorkFormFooter: React.FC<AddWorkFormFooterProps> = ({
  onCancel,
  submitError,
  isSubmitting,
  isLoadingDefaults,
}) => {
  const isDisabled = isSubmitting || isLoadingDefaults;

  return (
    <div
      className={
        "flex items-center justify-end gap-3 border-t border-gray-200 bg-white px-6 py-4 text-sm"
      }>
      {submitError && (
        <div className={"mr-auto text-sm font-bold text-error"}>
          {submitError}
        </div>
      )}
      <Button
        colorType={"outline"}
        label={"Cancel"}
        onClick={onCancel}
        buttonType={"button"}
        disabled={isDisabled}
        size={"custom"}
        extraClasses={
          "normal-case h-8 min-h-0 !w-[100px] px-0 py-0 text-sm font-medium"
        }
      />
      <Button
        buttonType={"submit"}
        label={"Create"}
        disabled={isDisabled}
        isLoading={isSubmitting}
        size={"custom"}
        extraClasses={
          "normal-case h-8 min-h-0 !w-[100px] px-0 py-0 text-sm font-medium"
        }
      />
    </div>
  );
};
